// src/features/admin/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../hooks/useAdminAuth';

const ProtectedRoute = ({ children }) => {
  const { isAdmin, loading, user } = useAdminAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication and role
  if (loading) {
    return (
      <div className="min-h-screen bg-brand-black flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-gold mx-auto mb-4"></div>
          <p className="text-brand-light/70">Verifying admin access...</p>
        </div>
      </div>
    );
  }

  // Strict enforcement: Only allow access if user has admin role in Firestore
  // This check happens in useAdminAuth hook, which verifies role === 'admin' in users/{uid}
  if (!isAdmin || !user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Render protected content only if user is authenticated AND has admin role
  return children;
};

export default ProtectedRoute;